export const API_VER = "";
let AIS_HOST, SGD_HOST, SGD_API_HOST, LOG_SIGNALR, MAHUB_HOST;
AIS_HOST = process.env.REACT_APP_AIS_HOST;
SGD_HOST =  process.env.REACT_APP_SGD_HOST;
SGD_API_HOST= process.env.REACT_APP_SGD_API_HOST;
MAHUB_HOST =  process.env.REACT_APP_MAHUB_HOST;
export const API_URL_OIDC =  process.env.REACT_APP_API_URL_OIDC;
export { AIS_HOST, SGD_HOST,SGD_API_HOST, MAHUB_HOST};
